import Bowser from 'bowser'

export default function() {
  const ua = navigator.userAgent
  const browser = Bowser.getParser(ua)
  let flag

  if (browser.satisfies({ chrome: '>=0', chromium: '>=0' })) {
    flag = 'chrome'
  } else if (browser.satisfies({ firefox: '>=0' })) {
    flag = 'firefox'
  } else if (browser.satisfies({ safari: '>=0' })) {
    flag = 'safari'
  } else if (browser.satisfies({ opera: '>=0' })) {
    flag = 'opera'
  } else if (browser.satisfies({ 'microsoft edge': '>=0' })) {
    flag = 'edge'
  } else {
    flag = 'unknown'
  }

  const isMobile = browser.isPlatform('mobile')
                   || browser.isPlatform('tablet')
                   // ↓iPadOS13を検出するための判定
                   || navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1

  /**
   * NOTE: 各ブラウザのgetDisplayMedia対応状況
   * https://developer.mozilla.org/en-US/docs/Web/API/MediaDevices/getDisplayMedia#Browser_compatibility
   */
  const isSupportedShare = browser.satisfies({
    desktop: {
      chrome: ">=72",
      firefox: ">=66",
      safari: ">=13",
      opera: ">=60",
      'microsoft edge': ">=79"
    }
  })

  return {
    flag,
    name: browser.getBrowserName(),
    version: browser.getBrowserVersion(),
    isMobile: isMobile,
    isSupportedShare: isSupportedShare
  };
}
